export default {
  id: 'login',
  title: 'Sign-in screen',
  note: 'Shown before anyone is authenticated.',
  texts: {
    'login.brand.alt': 'HiTrail',
    'login.brand.sub': 'MAS',
    'login.heading': 'Sign in to MAS',
    'login.sub': 'Enter your operator credentials to access the settlement console.',
    'login.env.prd': 'PRD · Production',
    'login.field.username': 'Username or email',
    'login.field.usernamePlaceholder': 'admin',
    'login.field.password': 'Password',
    'login.field.passwordPlaceholder': '••••••••••••',
    'login.keepSignedIn': 'Keep me signed in on this device (8h max)',
    'login.submit': 'Sign in to MAS',
    'login.submitBusy': 'Signing in…',
    'login.forgotPassword': 'Forgot password?',
    'login.error.failed': 'Sign-in failed',
    'login.footer.region': 'EU-Central · Frankfurt',
    'login.art.line1': 'Inter-carrier revenue sharing,',
    'login.art.line2a': 'settled ',
    'login.art.line2b': 'automatically',
    'login.art.line2c': ' — and audited',
    'login.art.line3': 'to the cent.',
    'login.art.meta1': 'UIC 30301 · G6 settlement standard',
    'login.art.meta2a': '18 carriers · ',
    'login.art.meta2b': '128M cleared YTD · 99.998% reconciliation',
    'login.env.local': 'LOCAL · Development',
    'login.env.acc': 'ACC · Staging',
    'login.field.passwordHint': "First time signing in? You'll be prompted to change your password.",
    'login.ssoSaml': 'SSO via SAML',
    'login.footer.version': 'HiTrail MAS v2.4.1',
    'login.footer.statusLabel': 'Status: ',
    'login.footer.statusValue': '● operational',
  },
}
